import { AwardLead } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardLeads: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<AwardLead[]> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/leads`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardLead[]>(fetchContext.errorStore, response, 'get award leads'));
